const RANDOM_ID_BYTES = 16;

/** Create an unpredictable identifier for cross-context fencing. */
export function createSecureRandomId(prefix = ""): string {
  const cryptoApi = globalThis.crypto;
  if (typeof cryptoApi?.randomUUID === "function") {
    return `${prefix}${cryptoApi.randomUUID()}`;
  }
  if (typeof cryptoApi?.getRandomValues !== "function") {
    throw new Error("Web Crypto is required for authentication session fencing");
  }

  const bytes = cryptoApi.getRandomValues(new Uint8Array(RANDOM_ID_BYTES));
  let encoded = "";
  for (const byte of bytes) encoded += byte.toString(16).padStart(2, "0");
  return `${prefix}${encoded}`;
}
